import React, { useState, useEffect } from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import axios from 'axios';
import Nav from 'react-bootstrap/Nav';
import Info from '../pages/Info';
import Appointment from '../pages/Appointment';
import Record from '../pages/Record';
import ScrollArrow from '../components/ScrollArrow';
import LoadingSpinner from '../components/LoadingSpinner';
import { MySwal, AlertSwal } from '../components/CustomSwal';
import { FormattedMessage, useIntl } from 'react-intl';

function Space(props) {
  const [current, setCurrent] = useState(props.location.pathname.split('redirect_to/')[1]);
  const [session, setSession] = useState(null);
  const [showScrollArrow, setShowScrollArrow] = useState(false);
  const [scrollCount, setScrollCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingCount, setLoadingCount] = useState(0);
  // check session
  const sid = sessionStorage.getItem('sid');
  const authid = sessionStorage.getItem('authid');
  const config = props.config;
  const intl = useIntl();

  const handlePage = (selectedKey) => {
    if (selectedKey !== 'logout') {
      setCurrent(selectedKey);
      props.history.push('/redirect_to/' + selectedKey);
    } else {
      MySwal.fire({
        title: intl.formatMessage({ id: 'global.logout' }),
        html: intl.formatMessage({ id: 'global.confirm_logout' }) + '？',
        showCancelButton: true,
        confirmButtonText: intl.formatMessage({ id: 'global.confirm' }),
        cancelButtonText: intl.formatMessage({ id: 'global.cancel' })
      }).then((result) => {
        if (result.value) {
          sessionStorage.removeItem('userid');
          sessionStorage.removeItem('sid');
          sessionStorage.removeItem('authid');
          sessionStorage.removeItem('isblacklist');
          sessionStorage.removeItem('cardnoexist');
          props.history.push('/');
        }
      });
    }
  }

  const triggerLoading = (bool) => {
    if (bool) {
      setLoadingCount(prevCount => prevCount + 1);
    } else {
      setLoadingCount(prevCount => prevCount - 1);
    }
  }

  const triggerScroll = (bool,is2nd) => {
    if (bool) {
      setScrollCount(prevCount => prevCount + 1);
    } else {
      if (is2nd === 1) {
        setShowScrollArrow(false);
      } 
      setScrollCount(prevCount => prevCount - 1);
    }
  }

  const CheckSession = () => {
    triggerLoading(true);
    axios.get(config.API_URL + `/GetBookInfo.aspx`, {
      params: {
        sid: sid,
        authid: authid,
        restype: 'json'
      }
    }).then((res) => {
      const data = res.data[0];
      if (data.rescode === '3' || data.rescode === '4') {
        setSession(false);
      } else {
        if (data.rescode === '1') {
          setSession(true);
        } else {
          AlertSwal.fire({
            title: intl.formatMessage({ id: 'global.alert_title' }),
            text: data.resmsg,
            confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
          })
        }
      }
    }).catch((error) => {
      console.error(error)
    }).finally(() => {
      triggerLoading(false);
    })
  }

  useEffect(() => {
    if (loadingCount === 0) {
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [loadingCount])

  useEffect(() => {
    if (scrollCount === 0) {
      setShowScrollArrow(false);
    } else {
      setShowScrollArrow(true);
    }
  }, [scrollCount])

  useEffect(CheckSession, []);

  useEffect(() => {
    document.body.classList.add('logged');
    return () => {
      document.body.classList.remove('logged');
    };
  }, []);

  if (session === null) {
    return <LoadingSpinner loading={true} />;
  } else if (session === false) {
    return <Link to='/'>Invalid Session. Please Login to Continue.</Link>;
  } else {
    const pageTitle = {
      'info': <FormattedMessage id="global.info" />,
      'appointment': <FormattedMessage id="global.appointment" />,
      'record': <FormattedMessage id="global.record" />,
      'logout': <FormattedMessage id="global.logout" />
    }
    const navItems = Object.keys(pageTitle).map(key =>
      <Nav.Item key={key} navkey={key}>
        <Nav.Link eventKey={key} className="d-flex flex-column_custom justify-content-center">
          <i className={key}></i>
          <span>{pageTitle[key]}</span>
        </Nav.Link>
      </Nav.Item>
    )
    return (
      <>
        <div id="topbar" className="bg_brand">
          <dl className="d-flex justify-content-between mb-0 w-100">
            <dt className="w-25 align-self-center">
              {/* <span className="d-flex justify-content-center"><i
                className="redirect" onClick={() => { props.setLocale(props.locale === 'zh' ? 'en' : 'zh') }}></i></span> */}
            </dt>
            <dt className="w-50 align-self-center"><span className="d-flex justify-content-center">{pageTitle[current]}</span></dt>
            <dt className="w-25 align-self-center"><span className="d-flex justify-content-center" onClick={() => { handlePage('logout'); }}>{pageTitle['logout']}</span></dt>
          </dl>
        </div>
        <Nav className="bg_brand" id="tabbar" justify variant="tabs" activeKey={current} onSelect={(selectedKey) => { handlePage(selectedKey); }}>
          {navItems}
        </Nav>
        <main>
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <Switch>
                  {/* The component will show here if the current URL matches the path */}
                  <Route path="/redirect_to/info"
                    render={() =>
                      <Info {...props}
                        setSession={setSession}
                        setLoading={triggerLoading}
                        setShowScrollArrow={triggerScroll}
                      />}
                  />
                  <Route path="/redirect_to/appointment"
                    render={() =>
                      <Appointment {...props}
                        setCurrent={setCurrent}
                        setSession={setSession}
                        setLoading={triggerLoading}
                        setScrollCount={setScrollCount}
                        setShowScrollArrow={triggerScroll}
                      />}
                  />
                  <Route path="/redirect_to/record"
                    render={() =>
                      <Record {...props}
                        setCurrent={setCurrent}
                        setSession={setSession}
                        setLoading={triggerLoading}
                        setShowScrollArrow={triggerScroll}
                      />}
                  />
                </Switch>
              </div>
            </div>
          </div>
        </main>
        <LoadingSpinner loading={loading} />
        {showScrollArrow ? <ScrollArrow totopPixel={config.TO_TOP_PIXEL} scrollCount={scrollCount} /> : null}
      </>
    );
  }
}

export default Space;
